export default class CurrencyTotalItem {
  constructor(amount, currency, revenue = false, textDecoration = false) {
    this.amount = amount
    this.currency = currency
    this.revenue = revenue
    this.textDecoration = textDecoration
  }
}
